var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{ref:"iconElement",class:['zt-icon', 'align-middle leading-none tracking-normal', _vm.iconClass]})
}
var staticRenderFns = []

export { render, staticRenderFns }